import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCustomFieldById as GetCustomFieldByIdQuery,
    GetCustomFieldByIdVariables as GetCustomFieldByIdVariables,
    GetCustomFieldById_customField as CustomField,
} from 'nutshell-graphql-types';

import GET_CUSTOM_FIELD_BY_ID from '../queries/get-custom-field-by-id.graphql';

export const useGetCustomFieldById = (
    id?: string | null
): {
    customField: CustomField | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetCustomFieldByIdQuery,
        GetCustomFieldByIdVariables
    >(GET_CUSTOM_FIELD_BY_ID, {
        variables: id ? {id} : undefined,
        skip: !id,
    });

    const customField = data ? data.customField : null;

    return {
        customField,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
